import { type MaybeRefOrGetter, toValue } from "vue"
import type {
  ApplyMode,
  ProviderKey,
} from "@versatile-credit-apply/omni-apply-client"
import { useRouter, type Router } from "vue-router"

interface UseTransitionToNextLenderOverrides {
  providerKey?: ProviderKey
  applyMode?: ApplyMode
}

export function useTransitionToNextLender(): (
  overrides: UseTransitionToNextLenderOverrides
) => ReturnType<Router["replace"]>

export function useTransitionToNextLender(
  nextProviderKey: MaybeRefOrGetter<ProviderKey | undefined>,
  nextApplyMode: MaybeRefOrGetter<ApplyMode | undefined>,
  autoSubmit?: MaybeRefOrGetter<boolean | undefined>
): (
  overrides?: UseTransitionToNextLenderOverrides
) => ReturnType<Router["replace"]>

export function useTransitionToNextLender(
  nextProviderKey?: MaybeRefOrGetter<ProviderKey | undefined>,
  nextApplyMode?: MaybeRefOrGetter<ApplyMode | undefined>,
  autoSubmit?: MaybeRefOrGetter<boolean | undefined>
) {
  const router = useRouter()

  return (overrides: UseTransitionToNextLenderOverrides = {}) => {
    const providerKey = overrides.providerKey ?? toValue(nextProviderKey)
    const applyMode = overrides.applyMode ?? toValue(nextApplyMode)

    if (providerKey && applyMode) {
      return router.replace({
        path: `/apply/providers/${encodeURIComponent(providerKey)}/${applyMode}/switch`,
        query: {
          autoSubmit: toValue(autoSubmit) ? "true" : "false",
        },
      })
    }

    return Promise.resolve(undefined)
  }
}
